// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"699":"a146e0ac","811":"14bda11d"}[chunkId] + ".chunk.css";
};